import styled from 'styled-components';

import { Button, Card, Grid2 as Grid } from '@mui/material';

export const ContentContainer = styled(Card)`
  box-shadow: none;
`;
export const ClearFilterButton = styled(Button)`
  margin-left: 10%;
  text-transform: none;
  text-decoration: underline;
  &:hover,
  &:focus,
  &:active {
    background-color: transparent;
    text-decoration: underline;
  }
  width: 45%;
  height: 60%;
`;

export const ButtonFilterContainer = styled(Grid)``;

export const FilterButton = styled(Button)`
  width: 45%;
  background-color: var(--mui-palette-primary-main) !important;
`;
